export default "__VITE_ASSET__26038ce0__"